import { atom } from "jotai";
import { getBlocks, getProjectLists } from "../../services/settings/service";

const settingsAtom = atom({
    userDetails: {},  
    projectList: [], 
    blockList: {}    
});

export const getUserData = atom(null, async (_, set, args) => {
  set(settingsAtom, (prev) => ({ ...prev, userDetails: args })); 
});

export const getProjectList = atom(null, async (_, set, args) => {
    const res = await getProjectLists()
    if(res) {
        set(settingsAtom, (prev) => ({ ...prev, projectList: res.data })); 
    }
});


export const fetchBlocks = atom(null, async (_, set, args) => {
    const res = await getBlocks()
    if(res) {
        set(settingsAtom, (prev) => ({ ...prev, blockList: res.data })); 
    }
});

export default settingsAtom;
